import React from "react"
import { useStaticQuery, graphql } from "gatsby"

const graphqlQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
  }
`

type Props = {
  title?: string
  description?: string
  image?: string
}

export const SEO = ({ title, description, image = "" }: Props) => {
  const { site } = useStaticQuery(graphqlQuery)

  const metaDescription = description || site.siteMetadata.description
  const metaTitle = `${title || site.siteMetadata.title} | ${
    site.siteMetadata.title
  }`

  return (
    <>
      <title>{metaTitle}</title>
      {process.env.GATSBY_DISABLE_SEO && (
        <meta name="robots" content="noindex" />
      )}
      <meta name="description" content={metaDescription} />
      <meta property="og:title" content={metaTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={metaTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={image} />
    </>
  )
}
